// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.other-management {
  position: relative; /* Ensure child elements are positioned relative to this container */
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 1rem;
  gap: 2rem;
}
.other-management__header {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.other-management__header :global(.page-hierarchy) {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.other-management__header .p-inputgroup {
  position: relative;
}
.other-management__header .p-inputgroup .p-inputgroup-addon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  background: none;
  border: none;
  color: #64748B;
}
.other-management__header .p-inputgroup .p-inputtext {
  padding-left: 2.5rem;
  width: 100%;
  height: 40px;
  font-size: 0.9rem;
}
.other-management__no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 75vh;
  text-align: center;
  color: #64748B;
}
.other-management__no-data p {
  margin-bottom: 1rem;
}
.other-management__no-data .p-button-link {
  color: #4F4BFF;
  text-decoration: underline;
}
.other-management__no-data .p-button-link:hover {
  color: #3f3ccc;
}

@media screen and (max-width: 768px) {
  .other-management {
    padding: 2rem;
    gap: 0.5rem;
  }
  .other-management__header {
    gap: 1rem;
    margin-bottom: 0.25rem;
  }
  .other-management__header .page-hierarchy {
    font-size: 1.2rem;
  }
  .other-management__filters-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 400px;
    max-height: 80vh;
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    overflow-y: auto;
  }
  .other-management__filters-popup__item {
    display: flex;
    align-items: center;
    padding: 1rem;
    gap: 1rem;
    border-bottom: 1px solid #f5f5f5;
  }
  .other-management__filters-popup__item label {
    font-size: 1rem;
    flex: 1 1;
  }
  .other-management__filters-popup__item .p-checkbox {
    width: 24px;
    height: 24px;
  }
  .other-management__filter-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9998;
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(193, 193, 193, 0.32);
  z-index: 100;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 101;
}

.mobile-shop-selector {
  width: 100%;
}
.mobile-shop-selector__option {
  padding: 0.75rem;
}
.mobile-shop-selector__option__name {
  font-weight: 500;
  margin-bottom: 0.25rem;
}
.mobile-shop-selector__option__address {
  font-size: 0.85rem;
  color: #64748B;
}

.mobile-controls {
  display: flex;
  gap: 0.5rem;
  width: 100%;
}
.mobile-controls .p-inputgroup {
  flex: 1 1;
}
.mobile-controls .p-inputgroup .p-inputtext {
  border-radius: 6px;
}
.mobile-controls .filter-button {
  height: 40px;
  background-color: transparent;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.mobile-controls .filter-button.filters-active {
  background-color: #4F4BFF;
  color: white;
}
.mobile-controls .filter-button.filters-active:hover {
  background-color: #3f3ccc;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/other-management/other-management.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA,EAAA,oEAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AACR;AACQ;EACI,iBAAA;EACA,gBAAA;EACA,qBAAA;AACZ;AAEQ;EACI,kBAAA;AAAZ;AAEY;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AAAhB;AAGY;EACI,oBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AADhB;AAgBI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAdR;AAgBQ;EACI,mBAAA;AAdZ;AAiBQ;EACI,cAAA;EACA,0BAAA;AAfZ;AAiBY;EACI,cAAA;AAfhB;;AAqBA;EACI;IACI,aAAA;IACA,WAAA;EAlBN;EAoBM;IACI,SAAA;IACA,sBAAA;EAlBV;EAoBU;IACI,iBAAA;EAlBd;EAsBM;IACI,eAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IACA,UAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,eAAA;IACA,0CAAA;IACA,aAAA;IACA,gBAAA;EApBV;EAsBU;IACI,aAAA;IACA,mBAAA;IACA,aAAA;IACA,SAAA;IACA,gCAAA;EApBd;EAsBc;IACI,eAAA;IACA,SAAA;EApBlB;EAuBc;IACI,WAAA;IACA,YAAA;EArBlB;EA0BM;IACI,eAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,8BAAA;IACA,aAAA;EAxBV;AACF;AA4BA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;AA1BJ;;AA6BA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;AA1BJ;;AA6BA;EACI,WAAA;AA1BJ;AA4BI;EACI,gBAAA;AA1BR;AA4BQ;EACI,gBAAA;EACA,sBAAA;AA1BZ;AA6BQ;EACI,kBAAA;EACA,cAAA;AA3BZ;;AAgCA;EACE,aAAA;EACA,WAAA;EACA,WAAA;AA7BF;AA+BE;EACE,SAAA;AA7BJ;AA8BI;EACE,kBAAA;AA5BN;AAgCE;EACE,YAAA;EACA,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AA9BJ;AAgCI;EACE,yBAAA;EACA,YAAA;AA9BN;AAgCM;EACE,yBAAA;AA9BR","sourcesContent":[".other-management {\n    position: relative; /* Ensure child elements are positioned relative to this container */\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    padding: 1rem;\n    gap: 2rem;\n\n    &__header {\n        display: flex;\n        flex-direction: column;\n        gap: 1.5rem;\n\n        :global(.page-hierarchy) {  // Target the page hierarchy component\n            font-size: 1.2rem;\n            font-weight: 600;\n            margin-bottom: 0.5rem;\n        }\n\n        .p-inputgroup {\n            position: relative;\n            \n            .p-inputgroup-addon {\n                position: absolute;\n                left: 0.75rem;\n                top: 50%;\n                transform: translateY(-50%);\n                z-index: 1;\n                background: none;\n                border: none;\n                color: #64748B;\n            }\n            \n            .p-inputtext {\n                padding-left: 2.5rem;\n                width: 100%;\n                height: 40px;\n                font-size: 0.9rem;\n            }\n        }\n\n        // .add-button {\n        //     width: fit-content;\n        //     height: 40px;\n        //     background-color: #4F4BFF;\n        //     color: white;\n        //     border-color: #DEDEDE;\n        //     border-radius: 6px;\n        //     font-size: 0.85rem;\n        // }\n    }\n\n    &__no-data {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        height: 75vh;\n        text-align: center;\n        color: #64748B;\n        \n        p {\n            margin-bottom: 1rem;\n        }\n\n        .p-button-link {\n            color: #4F4BFF;\n            text-decoration: underline;\n            \n            &:hover {\n                color: #3f3ccc;\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .other-management {\n        padding: 2rem;\n        gap: 0.5rem;\n        \n        &__header {\n            gap: 1rem;\n            margin-bottom: 0.25rem;\n\n            .page-hierarchy {\n                font-size: 1.2rem;\n            }\n        }\n\n        &__filters-popup {\n            position: fixed;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n            width: 90%;\n            max-width: 400px;\n            max-height: 80vh;\n            background: white;\n            border-radius: 16px;\n            padding: 1.5rem;\n            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n            z-index: 9999;\n            overflow-y: auto;\n\n            &__item {\n                display: flex;\n                align-items: center;\n                padding: 1rem;\n                gap: 1rem;\n                border-bottom: 1px solid #f5f5f5;\n\n                label {\n                    font-size: 1rem;\n                    flex: 1;\n                }\n\n                .p-checkbox {\n                    width: 24px;\n                    height: 24px;\n                }\n            }\n        }\n\n        &__filter-backdrop {\n            position: fixed;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background: rgba(0, 0, 0, 0.5);\n            z-index: 9998;\n        }\n    }\n}\n\n.mask {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(193, 193, 193, 0.32);\n    z-index: 100;\n}\n\n.popup {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    z-index: 101;\n}\n\n.mobile-shop-selector {\n    width: 100%;\n    \n    &__option {\n        padding: 0.75rem;\n        \n        &__name {\n            font-weight: 500;\n            margin-bottom: 0.25rem;\n        }\n        \n        &__address {\n            font-size: 0.85rem;\n            color: #64748B;\n        }\n    }\n}\n\n.mobile-controls {\n  display: flex;\n  gap: 0.5rem;\n  width: 100%;\n\n  .p-inputgroup {\n    flex: 1;\n    .p-inputtext {\n      border-radius: 6px;  // Match the filter button radius\n    }\n  }\n\n  .filter-button {\n    height: 40px;\n    background-color: transparent;\n    color: black;\n    border-color: #DEDEDE;\n    border-radius: 6px;\n    font-size: 0.85rem;\n\n    &.filters-active {\n      background-color: #4F4BFF;\n      color: white;\n      \n      &:hover {\n        background-color: #3f3ccc;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
